export function initSolutions() {
    const nav = document.querySelector('.solutions__nav');
    if (!nav) return;

    const pairs = [...nav.querySelectorAll('.solutions__btn')]
        .map(tab => ({
            tab,
            panel: document.getElementById(tab.dataset.tab),
        }))
        .filter(pair => pair.panel);
    const tabs = pairs.map(pair => pair.tab);
    const panels = pairs.map(pair => pair.panel);

    if (!tabs.length || !panels.length) return;

    // --- Progressive enhancement: add all ARIA via JS ---

    nav.setAttribute('role', 'tablist');
    nav.setAttribute('aria-label', 'Our Solutions');

    tabs.forEach((tab, i) => {
        const panelId = tab.dataset.tab;
        const tabId   = `solutions-tab-${panelId}`;

        tab.setAttribute('role', 'tab');
        tab.setAttribute('id', tabId);
        tab.setAttribute('aria-controls', panelId);
        tab.setAttribute('aria-selected', tab.classList.contains('is-active') ? 'true' : 'false');
        tab.setAttribute('tabindex', tab.classList.contains('is-active') ? '0' : '-1');
    });

    panels.forEach(panel => {
        const controllingTab = tabs.find(t => t.dataset.tab === panel.id);

        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', controllingTab ? controllingTab.id : '');
        panel.setAttribute('tabindex', '0');

        const isActive = panel.classList.contains('is-active');
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        if (!isActive) {
            setFocusable(panel, false);
        }
    });

    // --- Helpers ---

    function setFocusable(panel, enabled) {
        const FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';
        panel.querySelectorAll(FOCUSABLE).forEach(el => {
            el.setAttribute('tabindex', enabled ? '0' : '-1');
        });
        panel.setAttribute('tabindex', enabled ? '0' : '-1');
    }

    function activate(index) {
        tabs.forEach((tab, i) => {
            const active = i === index;

            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', String(active));
            tab.setAttribute('tabindex', active ? '0' : '-1');
        });

        panels.forEach((panel, i) => {
            const active = i === index;

            panel.classList.toggle('is-active', active);
            panel.setAttribute('aria-hidden', String(!active));
            setFocusable(panel, active);
        });
    }

    // --- Click ---

    tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => {
            activate(i);
            tab.focus();
        });
    });

    // --- Keyboard: ARIA APG Tabs pattern ---
    // Arrow keys move focus + activate; Home/End jump to ends

    nav.addEventListener('keydown', (e) => {
        const current = tabs.indexOf(document.activeElement);
        if (current === -1) return;

        let next = current;

        if (e.key === 'ArrowRight') {
            next = (current + 1) % tabs.length;
        } else if (e.key === 'ArrowLeft') {
            next = (current - 1 + tabs.length) % tabs.length;
        } else if (e.key === 'Home') {
            next = 0;
        } else if (e.key === 'End') {
            next = tabs.length - 1;
        } else {
            return;
        }

        e.preventDefault();
        activate(next);
        tabs[next].focus();
    });

    // --- Hash ---

    function activateByHash(hash, moveFocus) {
        const id = hash.replace('#', '');
        const index = tabs.findIndex(t => t.dataset.tab === id);
        if (index === -1) return false;
        activate(index);
        if (moveFocus) tabs[index].focus();
        return true;
    }

    // On load: honour existing hash, otherwise set hash for default active tab
    if (window.location.hash) {
        activateByHash(window.location.hash, false);
        // Prevent the browser from auto-scrolling to the hash anchor element
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                window.scrollTo(0, 0);
            });
        });
    }

    // On click: push hash without scrolling
    tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => {
            history.pushState(null, '', `#${tab.dataset.tab}`);
        });
    });

    // Browser back/forward
    window.addEventListener('popstate', () => {
        if (window.location.hash) {
            activateByHash(window.location.hash, false);
        }
    });
}
